const isPositiveInt = (value) => /^\d+$/.test(String(value)) && Number(value) > 0;

export const validatePopupForm = ({ hasImage, width, height, start_date, end_date }) => {
  if (!hasImage) return "이미지를 업로드해 주세요.";
  if (!isPositiveInt(width)) return "가로 크기를 1 이상의 정수로 입력해 주세요.";
  if (!isPositiveInt(height)) return "세로 크기를 1 이상의 정수로 입력해 주세요.";
  if (!Number.isFinite(Number(start_date)) || !Number.isFinite(Number(end_date)))
    return "게시일과 만료일을 입력해 주세요.";
  if (!(Number(end_date) > Number(start_date))) return "만료일은 게시일보다 뒤여야 합니다.";
  return null;
};

/** 브라우저에서 이미지 파일의 원본 픽셀 크기를 읽는다. 실패하면 null */
export const readImageSize = (file) =>
  new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      resolve(null);
    };
    img.src = url;
  });
